export default "/images/vendor/flag-icon-css/flags/1x1/bl.svg?669bbb820754f1cc0ce4bf010c056e23";